import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export type InterpreterDashboardFilters = {
  startDate?: string
  endDate?: string
  languages?: string[]
}

export type InterpreterDashboardChartPointDto = {
  label: string
  value: number
}

export type InterpreterDashboardOverviewDto = {
  summary?: {
    openAppointments?: number
    confirmedAppointments?: number
    vosRequiredAppointments?: number
    streakDays?: number
    maxStreakDays?: number
  }
  earningsOverview?: {
    totalApproved?: number
    points?: InterpreterDashboardChartPointDto[]
  }
  opiMetrics?: {
    totalCalls?: number
    totalMinutes?: number
    avgDurationMinutes?: number
    avgWaitMinutes?: number
    growthPoints?: InterpreterDashboardChartPointDto[]
  }
  ipiMetrics?: {
    completedIpi?: number
    payableHours?: number
    cancelRate?: number
    acceptanceRate?: number
    growthPoints?: InterpreterDashboardChartPointDto[]
  }
  upcomingSchedule?: Array<{
    appointmentId: number
    startTime: string
    endTime: string
    customerName: string
    language: string
    location: string
  }>
}

export type InterpreterLanguageOption = {
  key: string
  value: string
}

export async function getInterpreterOverview(
  filters: InterpreterDashboardFilters
): Promise<InterpreterDashboardOverviewDto> {
  const response = await axios.post(`${API_URL}/Dashboard/interpreter-overview`, filters)
  return response.data?.data ?? {}
}

export async function getInterpreterLanguages(): Promise<InterpreterLanguageOption[]> {
  const response = await axios.get(`${API_URL}/Dashboard/interpreter-languages`)
  return response.data?.data ?? []
}
